import { useEffect, MutableRefObject } from 'react'

type UseClickOutSideParams = {
	ref: MutableRefObject<HTMLElement | null>
	handler: () => void
}

export function useClickOutside({ ref, handler }: UseClickOutSideParams) {
  useEffect(
    () => {
      const listener = (event: any) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler();
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}